import React, { useContext } from 'react';
import { ACTIONS } from '../../../../../constants';
import { AppContext } from '../../../../context';
import { ReportItem } from '../MenuItem';
import { getActionService } from '../../../../../utils/getActionService';
import { DownloadReportsModel, EmployeeNodeModel } from '../../../../../models';
import { toast } from 'react-toastify';
import { getEmployeesIds } from '../../../../../utils';
import { handleDownloadReport } from '../../../../../utils/handleDownloadReport';

interface Props {
    startDateScheduling: string;
    selectedEmployees: EmployeeNodeModel[];
    endDateScheduling: string;
}

export const NoveltiesMenuGroup: React.FC<Props> = ({
    endDateScheduling,
    selectedEmployees,
    startDateScheduling,
}) => {
    const { langResources, downloadReport, userInfo } = useContext(AppContext);

    /**
     * Descarga el reporte de Promedio de Tiempos Trabajados
     */
    const handlerSaveReportWorkshiftsWithoutMarking = () => {
        handleDownloadReport(
            startDateScheduling,
            endDateScheduling,
            getEmployeesIds(selectedEmployees),
            langResources['reports.message.alert'],
            langResources['workshift.scheduling.without.events.filename'],
            '/jerusalem/api/v2.0.0/reports/workshift-scheduling-without-events',
            downloadReport
        );
    };

    /**
     * Descarga el reporte de Marcaciones Incompletas
     */
    const handlerSaveReportIncompleteEvents = () => {
        handleDownloadReport(
            startDateScheduling,
            endDateScheduling,
            getEmployeesIds(selectedEmployees),
            langResources['reports.message.alert'],
            'Reporte de marcaciones incompletas',
            '/jerusalem/api/v2.0.0/reports/get-incomplete-events',
            downloadReport
        );
    };

    /**
     * Descarga el reporte de Programaciones sin Turno
     */
    const handlerSaveReportEventsWithoutWorkshiftScheduled = () => {
        handleDownloadReport(
            startDateScheduling,
            endDateScheduling,
            getEmployeesIds(selectedEmployees),
            langResources['reports.message.alert'],
            langResources['events.without.workshift.scheduled.filename'],
            '/jerusalem/api/v2.0.0/reports/event-without-workshift-scheduling',
            downloadReport
        );
    };

    /**
     * Descarga el reporte de Personal sin Programación
     */
    const handlerSaveReportEmployeesWithoutWorkshiftSchedulings = () => {
        handleDownloadReport(
            startDateScheduling,
            endDateScheduling,
            getEmployeesIds(selectedEmployees),
            langResources['reports.message.alert'],
            'Reporte Personal sin Programación',
            '/jerusalem/api/v2.0.0/reports/employees-without-workshift-schedulings',
            downloadReport
        );
    };

    /**
     * Descarga el Reporte de Auditoría de aprobación horas extras
     */
    const handlerSaveReportOvertimeApprovalAudit = () => {
        handleDownloadReport(
            startDateScheduling,
            endDateScheduling,
            getEmployeesIds(selectedEmployees),
            langResources['reports.message.alert'],
            'Reporte de Auditoría de aprobación horas extras',
            '/jerusalem/api/v2.0.0/reports/payroll-novelty-approval-logs',
            downloadReport
        );
    };

    const menuItems = [
        {
            action: ACTIONS['reports']['DialingWithoutScheduledShift'],
            label: langResources[
                'header.reports.marking.report.events.without.workshift.scheduled'
            ],
            handler: handlerSaveReportEventsWithoutWorkshiftScheduled,
        },
        {
            action: ACTIONS['reports']['IncompleteEvents'],
            label: 'Marcaciones incompletas',
            handler: handlerSaveReportIncompleteEvents,
        },
        {
            action: ACTIONS['reports']['EmployeesWithoutWorkshiftSchedulings'],
            label: 'Personal sin Programación',
            handler: handlerSaveReportEmployeesWithoutWorkshiftSchedulings,
        },
        {
            action: ACTIONS['reports']['OvertimeApprovalAuditReport'],
            label: 'Reporte de Auditoría de aprobación horas extras',
            handler: handlerSaveReportOvertimeApprovalAudit,
        },
        {
            action: ACTIONS['reports']['ScheduledShiftsWithoutDialing'],
            label: langResources[
                'header.reports.marking.report.workshifts.without.marking'
            ],
            handler: handlerSaveReportWorkshiftsWithoutMarking,
        },
    ];

    return (
        <li className='nav-item px-4'>
            <a
                className='nav-link text-dark d-flex align-items-center justify-content-between'
                data-bs-toggle='collapse'
                href='#'
            >
                <span>Novedades</span>
                <i className='ri-arrow-drop-right-line fs-5'></i>
            </a>

            <div id='sidebarEcommerce' className='menu-dropdown collapse p-1'>
                <ul className='nav nav-sm flex-column px-3'>
                    {menuItems.map(
                        ({ action, label, handler }, index) =>
                            getActionService(userInfo.actions, action) && (
                                <ReportItem
                                    key={index}
                                    label={label}
                                    handler={handler}
                                />
                            )
                    )}
                </ul>
            </div>
        </li>
    );
};
